import { configureStore } from '@reduxjs/toolkit';

import {
  createAuthSliceListenerMiddleware,
  createOrderSliceListenerMiddleware,
  updateOrderSliceListenerMiddleware,
  createBillSliceListenerMiddleware,
  updateBillSliceListenerMiddleware,
  createReturnBillSliceListenerMiddleware,
} from 'slice';

import errorMiddleware from './errorMiddleware';
import rootReducer from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(errorMiddleware)
      .prepend([
        createOrderSliceListenerMiddleware.middleware,
        updateOrderSliceListenerMiddleware.middleware,
        createBillSliceListenerMiddleware.middleware,
        createAuthSliceListenerMiddleware.middleware,
        updateBillSliceListenerMiddleware.middleware,
        createReturnBillSliceListenerMiddleware.middleware,
      ]), // not use array here, ref: https://stackoverflow.com/questions/68812319/redux-toolkit-argument-of-type-asyncthunkaction-is-not-assignable-to-param
});

export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
